import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "evses" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "section-header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_5 = { class: "type-data" }
const _hoisted_6 = { class: "emq-table-footer" }

import { retryOta, getEvseOtas } from '@/api/evses'
import { SEARCH_FORM_RES_PROPS as colProps } from '@/common/constants'
import EvseOTADrawer from './components/EvseOTADrawer.vue'
import PreWithEllipsis from '@/components/PreWithEllipsis.vue'
import CommonPagination from '@/components/commonPagination.vue'
import useI18nTl from '@/hooks/useI18nTl'
import usePaginationRemember from '@/hooks/usePaginationRemember'
import usePaginationWithHasNext from '@/hooks/usePaginationWithHasNext'
import { ArrowDown, ArrowUp, Refresh, RefreshLeft, Search, Plus } from '@element-plus/icons-vue'
import { pick } from 'lodash'
import SelectOperator from '@/components/SelectOperator.vue'
import EvseOTAStatus from '@/components/EvseOTAStatus.vue'
import { dateFormat, throttleBtn } from '@/common/tools'
import { ElMessage, ElMessageBox } from 'element-plus'
import EvseStatusSimple from '@/components/EvseStatusSimple.vue'
import LinkEvse from '@/components/Links/LinkEvse.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'

import { defineComponent, ref, computed, defineProps } from 'vue'

const __default__ = defineComponent({
  name: 'EvseOtas',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { t, tl } = useI18nTl('Evses')

const showEvseModelDialog = ref(false)

const showDialog = ref(false)
const editEditFlag = ref(false)
const showDialogEvse = ref({})

const showMoreQuery = ref(false)
const tableData = ref([])
const lockTable = ref(false)
const TableCom = ref()
const params = ref({})
const fuzzyParams = ref<Record<string, any>>({})
const { pageMeta, pageParams, initPageMeta, setPageMeta, toPageMeta } = usePaginationWithHasNext()
const { updateParams } = usePaginationRemember('evses-detail')

const retry = async (row: any) => {
  await ElMessageBox.confirm(tl('confirmRetryEvseOta'), {
    confirmButtonText: t('Base.confirm'),
    cancelButtonText: t('Base.cancel'),
    confirmButtonClass: 'confirm-danger',
    type: 'warning',
  })

  retryOta({ otaId: row.id })
    .then((res: any) => {
      ElMessage.success(t(`Base.retrySuccess`))
    })
    .catch((error: any) => {
      console.error('Error retry ota:', error)
    })
}

const addData = () => {
  editEditFlag.value = false
  showDialogEvse.value = {}
  showDialog.value = true
}
const editData = (row: any) => {
  editEditFlag.value = true
  showDialogEvse.value = row
  showDialog.value = true
}

const handleSearch = async () => {
  params.value = genQueryParams(fuzzyParams.value)
  loadDatas({ page: 1 })
}

const handleReset = () => {
  fuzzyParams.value = {}
  handleSearch()
}

const genQueryParams = (params: Record<string, any>) => {
  let newParams: Record<string, any> = {}
  const { id, modelName, vendor, operatorID } = params
  newParams = {
    id: id || undefined,
    modelName: modelName || undefined,
    vendor: vendor || undefined,
    operatorID: operatorID || undefined,
  }
  return newParams
}

const loadDatas = async (_params = {}) => {
  lockTable.value = true
  const sendParams = {
    ...params.value,
    pageReq: {
      ...pageParams.value,
      ..._params,
    },
  }

  try {
    const { list = [], pageReply = {} } = await getEvseOtas(sendParams)
    const meta = toPageMeta(sendParams.pageReq, pageReply)
    tableData.value = list
    setPageMeta(meta)
    updateParams({ ...pick(meta, ['limit', 'page']), ...params.value })
  } catch (error) {
    tableData.value = []
    initPageMeta()
  } finally {
    lockTable.value = false
  }
}
const loadDatasRefreshLimit = throttleBtn(loadDatas)
loadDatas()

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      class: "search-wrapper",
      onKeyup: _withKeys(handleSearch, ["enter"])
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.modelName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fuzzyParams.value.modelName) = $event)),
                  placeholder: _ctx.$t('Evses.model'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: fuzzyParams.value.vendor,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((fuzzyParams.value.vendor) = $event)),
                  placeholder: _ctx.$t('Evses.vendor'),
                  clearable: "",
                  onClear: handleSearch
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 16),
            _createVNode(_component_el_col, _normalizeProps(_guardReactiveProps(_unref(colProps))), {
              default: _withCtx(() => [
                _createVNode(SelectOperator, {
                  modelValue: fuzzyParams.value.operatorID,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fuzzyParams.value.operatorID) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 16),
            (showMoreQuery.value)
              ? (_openBlock(), _createBlock(_component_el_col, _normalizeProps(_mergeProps({ key: 0 }, _unref(colProps))), {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: fuzzyParams.value.id,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((fuzzyParams.value.id) = $event)),
                      placeholder: _ctx.$t('Evses.id'),
                      clearable: "",
                      onClear: handleSearch
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }, 16))
              : _createCommentVNode("", true),
            _createVNode(_component_el_col, _mergeProps(_unref(colProps), { class: "col-oper" }), {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  icon: _unref(Search),
                  onClick: handleSearch
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.search')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_button, {
                  icon: _unref(RefreshLeft),
                  onClick: handleReset
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.reset')), 1)
                  ]),
                  _: 1
                }, 8, ["icon"]),
                _createVNode(_component_el_tooltip, {
                  content: !showMoreQuery.value ? _ctx.$t('Base.showMore') : _ctx.$t('Base.lessMore'),
                  placement: "top"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      class: "icon-button",
                      plain: "",
                      icon: showMoreQuery.value ? _unref(ArrowUp) : _unref(ArrowDown),
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (showMoreQuery.value = !showMoreQuery.value))
                    }, null, 8, ["icon"])
                  ]),
                  _: 1
                }, 8, ["content"])
              ]),
              _: 1
            }, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["onKeyup"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          type: "primary",
          icon: _unref(Plus),
          onClick: _cache[5] || (_cache[5] = ($event: any) => (addData()))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.create')), 1)
          ]),
          _: 1
        }, 8, ["icon"])), [
          [_directive_role, 'evseOtaUpsert']
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          icon: _unref(Refresh),
          onClick: _unref(loadDatasRefreshLimit)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('Base.refresh')), 1)
          ]),
          _: 1
        }, 8, ["icon", "onClick"])
      ]),
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        ref_key: "TableCom",
        ref: TableCom,
        "row-key": "evseSn"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "sn",
            "min-width": "80",
            label: _ctx.$t('Evses.sn'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkEvse, {
                id: row.evseID,
                name: row.sn
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "state",
            "min-width": "50",
            label: _ctx.$t('Evses.state')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(EvseStatusSimple, {
                state: row.state
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "operatorName",
            "min-width": "50",
            label: _ctx.$t('Evses.operatorName'),
            show: "false"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(LinkOperator, {
                id: row.operatorID,
                name: row.operatorName
              }, null, 8, ["id", "name"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "model",
            "min-width": "80",
            label: _ctx.$t('Evses.model'),
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              (row.product == '')
                ? (_openBlock(), _createBlock(PreWithEllipsis, { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.model) + " - " + _toDisplayString(row.vendor), 1)
                    ]),
                    _: 2
                  }, 1024))
                : (_openBlock(), _createBlock(PreWithEllipsis, { key: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(row.model) + " - " + _toDisplayString(row.vendor) + " - " + _toDisplayString(row.product), 1)
                    ]),
                    _: 2
                  }, 1024))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "currentVersion",
            "min-width": "80",
            label: _ctx.$t('Evses.fromVersion')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "toVersion",
            "min-width": "80",
            label: _ctx.$t('Evses.toVersion')
          }, null, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "status",
            "min-width": "100",
            label: _ctx.$t('Evses.otaState')
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(EvseOTAStatus, {
                state: row.status
              }, null, 8, ["state"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            prop: "createdAt",
            "min-width": "80",
            label: _ctx.$t('Evses.createdAt')
          }, {
            default: _withCtx(({ row }) => [
              _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_table_column, {
            label: _ctx.$t('Base.operation'),
            "class-name": "table-operation"
          }, {
            default: _withCtx(({ row }) => [
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                size: "small",
                plain: "",
                onClick: ($event: any) => (retry(row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('Base.retry')), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])), [
                [_directive_role, 'evseOtaUpsert']
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["data"])), [
        [
          _directive_loading,
          lockTable.value,
          void 0,
          { lock: true }
        ]
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(CommonPagination, {
          metaData: _unref(pageMeta),
          "onUpdate:metaData": _cache[6] || (_cache[6] = ($event: any) => (_isRef(pageMeta) ? (pageMeta).value = $event : null)),
          onLoadPage: loadDatas
        }, null, 8, ["metaData"])
      ])
    ]),
    _createVNode(EvseOTADrawer, {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((showDialog).value = $event)),
      onSubmitted: loadDatas
    }, null, 8, ["modelValue"])
  ]))
}
}

})